// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Next = require("./next/Next.bs.js");
var React = require("react");
var Scalars = require("../scalars/Scalars.bs.js");
var Core__List = require("@rescript/core/src/Core__List.bs.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var CurrentUser = require("./common/CurrentUser/CurrentUser.bs.js");
var PathHistory = require("./PathHistory.bs.js");
var QueryParams = require("./QueryParams.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Form__Helpers = require("./common/Form/Form__Helpers.bs.js");
var Webapi__Dom__Document = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Document.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var PageViews_RecordPageViewV5Mutation_graphql = require("../__generated__/PageViews_RecordPageViewV5Mutation_graphql.bs.js");
var PageViews_RecordPageViewForLoggedInUserMutation_graphql = require("../__generated__/PageViews_RecordPageViewForLoggedInUserMutation_graphql.bs.js");

function make(page, resourceId, resourceType, secondaryResourceId, secondaryResourceType, qualifiedAgentId, data, param) {
  return {
          page: page,
          resourceId: resourceId,
          resourceType: resourceType,
          secondaryResourceId: secondaryResourceId,
          secondaryResourceType: secondaryResourceType,
          qualifiedAgentId: qualifiedAgentId,
          data: data
        };
}

function makePropertyPage(propertyId) {
  return make("PROPERTY_PAGE", propertyId, "PROPERTY", undefined, undefined, undefined, undefined, undefined);
}

function makePlansPage() {
  return {
          page: "PLANS_PAGE",
          resourceId: undefined,
          resourceType: undefined,
          secondaryResourceId: undefined,
          secondaryResourceType: undefined,
          qualifiedAgentId: undefined,
          data: undefined
        };
}

function makeBuyerNeedPage(buyerNeedId) {
  return make("BUYER_NEED_PAGE", buyerNeedId, "BUYER_NEED", undefined, undefined, undefined, undefined, undefined);
}

function makeAgentPage(agentId) {
  return make("AGENT_PAGE", agentId, "USER", undefined, undefined, undefined, undefined, undefined);
}

function makeAllInPage(messageId, qualifiedAgentId, secondaryResourceId, secondaryResourceType, param) {
  return make("ALL_IN_PAGE", messageId, "QA_MESSAGE", secondaryResourceId, secondaryResourceType, qualifiedAgentId, undefined, undefined);
}

function makePropertiesPage() {
  return {
          page: "PROPERTIES_PAGE",
          resourceId: undefined,
          resourceType: undefined,
          secondaryResourceId: undefined,
          secondaryResourceType: undefined,
          qualifiedAgentId: undefined,
          data: undefined
        };
}

function makeBuyerNeedsPage() {
  return {
          page: "BUYER_NEEDS_PAGE",
          resourceId: undefined,
          resourceType: undefined,
          secondaryResourceId: undefined,
          secondaryResourceType: undefined,
          qualifiedAgentId: undefined,
          data: undefined
        };
}

function makeShowingsPage() {
  return {
          page: "SHOWINGS_PAGE",
          resourceId: undefined,
          resourceType: undefined,
          secondaryResourceId: undefined,
          secondaryResourceType: undefined,
          qualifiedAgentId: undefined,
          data: undefined
        };
}

function makeActivityReportPage(entityType, entityId) {
  var tmp;
  switch (entityType) {
    case "BUYER_NEED" :
    case "RENTAL_NEED" :
        tmp = "client_need_";
        break;
    case "PROPERTY" :
    case "RENTAL_PROPERTY" :
        tmp = "property_";
        break;
    
  }
  return make("ACTIVITY_REPORT_PAGE", tmp + entityId, "ACTIVITY_REPORT", entityId, entityType, undefined, undefined, undefined);
}

function makeChapterDashboardPage() {
  return {
          page: "CHAPTER_DASHBOARD_PAGE",
          resourceId: undefined,
          resourceType: undefined,
          secondaryResourceId: undefined,
          secondaryResourceType: undefined,
          qualifiedAgentId: undefined,
          data: undefined
        };
}

function makeConversationsPage(conversationId, secondaryResource, param) {
  return make("CONVERSATIONS_PAGE", conversationId, Core__Option.map(conversationId, (function (param) {
                    return "CONVERSATION";
                  })), Core__Option.map(secondaryResource, (function (prim) {
                    return prim[1];
                  })), Core__Option.map(secondaryResource, (function (prim) {
                    return prim[0];
                  })), undefined, undefined, undefined);
}

function makeNewSellerPage() {
  return {
          page: "NEW_SELLER_PAGE",
          resourceId: undefined,
          resourceType: undefined,
          secondaryResourceId: undefined,
          secondaryResourceType: undefined,
          qualifiedAgentId: undefined,
          data: undefined
        };
}

function makeNewSharePropertyPage() {
  return {
          page: "SHARE_PROPERTY_PAGE",
          resourceId: undefined,
          resourceType: undefined,
          secondaryResourceId: undefined,
          secondaryResourceType: undefined,
          qualifiedAgentId: undefined,
          data: undefined
        };
}

function makeMailedPropertyPage(propertyId, emailNotificationId, emailNotificationOwnerId) {
  return make("MAILED_PROPERTY_PAGE", propertyId, "PROPERTY", emailNotificationId, "EMAIL_NOTIFICATION", undefined, Object.fromEntries([[
                    "email_notification_owner_id",
                    emailNotificationOwnerId
                  ]]), undefined);
}

function makeMessagesPage() {
  return {
          page: "MESSAGES_PAGE",
          resourceId: undefined,
          resourceType: undefined,
          secondaryResourceId: undefined,
          secondaryResourceType: undefined,
          qualifiedAgentId: undefined,
          data: undefined
        };
}

var Page = {
  make: make,
  makePropertyPage: makePropertyPage,
  makePlansPage: makePlansPage,
  makeBuyerNeedPage: makeBuyerNeedPage,
  makeAgentPage: makeAgentPage,
  makeAllInPage: makeAllInPage,
  makePropertiesPage: makePropertiesPage,
  makeBuyerNeedsPage: makeBuyerNeedsPage,
  makeShowingsPage: makeShowingsPage,
  makeActivityReportPage: makeActivityReportPage,
  makeChapterDashboardPage: makeChapterDashboardPage,
  makeConversationsPage: makeConversationsPage,
  makeNewSellerPage: makeNewSellerPage,
  makeNewSharePropertyPage: makeNewSharePropertyPage,
  makeMailedPropertyPage: makeMailedPropertyPage,
  makeMessagesPage: makeMessagesPage
};

function tFromJs(s) {
  switch (s) {
    case "email" :
        return "EMAIL";
    case "web" :
        return "WEB";
    default:
      return ;
  }
}

function tToJs(t) {
  if (t === "WEB") {
    return "web";
  } else {
    return "email";
  }
}

var Medium = {
  tFromJs: tFromJs,
  tToJs: tToJs
};

function decode(param) {
  return Core__Option.flatMap(param, tFromJs);
}

function encode(param) {
  return Core__Option.map(param, tToJs);
}

var MediumParam = {
  decode: decode,
  encode: encode
};

var config = Object.fromEntries([
      [
        "as_c",
        QueryParams.UseQueryParams.ParamConfigs.stringParam
      ],
      [
        "as_ca",
        QueryParams.UseQueryParams.ParamConfigs.stringParam
      ],
      [
        "as_s",
        QueryParams.UseQueryParams.ParamConfigs.stringParam
      ],
      [
        "as_m",
        {
          encode: encode,
          decode: decode
        }
      ]
    ]);

var ParamsConfig = {
  MediumParam: MediumParam,
  config: config
};

var UseQueryParams = QueryParams.UseQueryParams.Make({
      config: config
    });

function anyIsPresent(x) {
  if (x.content !== undefined || x.campaign !== undefined || x.source !== undefined) {
    return true;
  } else {
    return x.medium !== undefined;
  }
}

function use() {
  var match = UseQueryParams.use();
  var setParams = match[1];
  var params = match[0];
  var params$p_content = params.as_c;
  var params$p_campaign = params.as_ca;
  var params$p_source = params.as_s;
  var params$p_medium = params.as_m;
  var params$p = {
    content: params$p_content,
    campaign: params$p_campaign,
    source: params$p_source,
    medium: params$p_medium
  };
  var clearParams = function () {
    setParams("replaceIn", {
          as_c: undefined,
          as_ca: undefined,
          as_s: undefined,
          as_m: undefined
        });
  };
  return [
          params$p,
          clearParams
        ];
}

function toQueryString(utm) {
  return new URLSearchParams(Core__Array.filterMap([
                    Core__Option.map(utm.medium, (function (m) {
                            return [
                                    "as_m",
                                    tToJs(m)
                                  ];
                          })),
                    Core__Option.map(utm.campaign, (function (ca) {
                            return [
                                    "as_ca",
                                    ca
                                  ];
                          })),
                    Core__Option.map(utm.content, (function (c) {
                            return [
                                    "as_c",
                                    c
                                  ];
                          })),
                    Core__Option.map(utm.source, (function (s) {
                            return [
                                    "as_s",
                                    s
                                  ];
                          }))
                  ], (function (x) {
                      return x;
                    }))).toString();
}

var UTM = {
  Medium: Medium,
  ParamsConfig: ParamsConfig,
  UseQueryParams: UseQueryParams,
  anyIsPresent: anyIsPresent,
  use: use,
  toQueryString: toQueryString
};

var convertVariables = PageViews_RecordPageViewV5Mutation_graphql.Internal.convertVariables;

var convertResponse = PageViews_RecordPageViewV5Mutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = PageViews_RecordPageViewV5Mutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, PageViews_RecordPageViewV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

var use$1 = RescriptRelay_Mutation.useMutation(convertVariables, PageViews_RecordPageViewV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

var RecordPageViewV5Mutation_mediumV5_decode = PageViews_RecordPageViewV5Mutation_graphql.Utils.mediumV5_decode;

var RecordPageViewV5Mutation_mediumV5_fromString = PageViews_RecordPageViewV5Mutation_graphql.Utils.mediumV5_fromString;

var RecordPageViewV5Mutation_pageV5_decode = PageViews_RecordPageViewV5Mutation_graphql.Utils.pageV5_decode;

var RecordPageViewV5Mutation_pageV5_fromString = PageViews_RecordPageViewV5Mutation_graphql.Utils.pageV5_fromString;

var RecordPageViewV5Mutation_pageViewViewerType_decode = PageViews_RecordPageViewV5Mutation_graphql.Utils.pageViewViewerType_decode;

var RecordPageViewV5Mutation_pageViewViewerType_fromString = PageViews_RecordPageViewV5Mutation_graphql.Utils.pageViewViewerType_fromString;

var RecordPageViewV5Mutation_resourceTypeV5_decode = PageViews_RecordPageViewV5Mutation_graphql.Utils.resourceTypeV5_decode;

var RecordPageViewV5Mutation_resourceTypeV5_fromString = PageViews_RecordPageViewV5Mutation_graphql.Utils.resourceTypeV5_fromString;

var RecordPageViewV5Mutation = {
  mediumV5_decode: RecordPageViewV5Mutation_mediumV5_decode,
  mediumV5_fromString: RecordPageViewV5Mutation_mediumV5_fromString,
  pageV5_decode: RecordPageViewV5Mutation_pageV5_decode,
  pageV5_fromString: RecordPageViewV5Mutation_pageV5_fromString,
  pageViewViewerType_decode: RecordPageViewV5Mutation_pageViewViewerType_decode,
  pageViewViewerType_fromString: RecordPageViewV5Mutation_pageViewViewerType_fromString,
  resourceTypeV5_decode: RecordPageViewV5Mutation_resourceTypeV5_decode,
  resourceTypeV5_fromString: RecordPageViewV5Mutation_resourceTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

var convertVariables$1 = PageViews_RecordPageViewForLoggedInUserMutation_graphql.Internal.convertVariables;

var convertResponse$1 = PageViews_RecordPageViewForLoggedInUserMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$1 = PageViews_RecordPageViewForLoggedInUserMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, PageViews_RecordPageViewForLoggedInUserMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var use$2 = RescriptRelay_Mutation.useMutation(convertVariables$1, PageViews_RecordPageViewForLoggedInUserMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var RecordPageViewForLoggedInUserMutation_mediumV5_decode = PageViews_RecordPageViewForLoggedInUserMutation_graphql.Utils.mediumV5_decode;

var RecordPageViewForLoggedInUserMutation_mediumV5_fromString = PageViews_RecordPageViewForLoggedInUserMutation_graphql.Utils.mediumV5_fromString;

var RecordPageViewForLoggedInUserMutation_pageV5_decode = PageViews_RecordPageViewForLoggedInUserMutation_graphql.Utils.pageV5_decode;

var RecordPageViewForLoggedInUserMutation_pageV5_fromString = PageViews_RecordPageViewForLoggedInUserMutation_graphql.Utils.pageV5_fromString;

var RecordPageViewForLoggedInUserMutation_resourceTypeV5_decode = PageViews_RecordPageViewForLoggedInUserMutation_graphql.Utils.resourceTypeV5_decode;

var RecordPageViewForLoggedInUserMutation_resourceTypeV5_fromString = PageViews_RecordPageViewForLoggedInUserMutation_graphql.Utils.resourceTypeV5_fromString;

var RecordPageViewForLoggedInUserMutation = {
  mediumV5_decode: RecordPageViewForLoggedInUserMutation_mediumV5_decode,
  mediumV5_fromString: RecordPageViewForLoggedInUserMutation_mediumV5_fromString,
  pageV5_decode: RecordPageViewForLoggedInUserMutation_pageV5_decode,
  pageV5_fromString: RecordPageViewForLoggedInUserMutation_pageV5_fromString,
  resourceTypeV5_decode: RecordPageViewForLoggedInUserMutation_resourceTypeV5_decode,
  resourceTypeV5_fromString: RecordPageViewForLoggedInUserMutation_resourceTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$2
};

function userAgent() {
  return window.navigator.userAgent;
}

function useRecordPageView(page) {
  var isImpersonated = CurrentUser.useIsImpersonated();
  var match = use$2();
  var recordPageViewForLoggedInUser = match[0];
  var match$1 = use$1();
  var recordPageView = match$1[0];
  var history = React.useContext(PathHistory.Context.context);
  var router = Next.useRouter();
  var currentPath = Next.Router.asPath(router);
  var queryParams = new URLSearchParams(Next.Router.query(router));
  var previousPath = Core__Option.flatMap(Core__List.tail(history), Core__List.head);
  var referrer = Core__Option.flatMap(Webapi__Dom__Document.asHtmlDocument(document), (function (doc) {
          return Form__Helpers.opt_of_string(doc.referrer);
        }));
  var userAgent$p = Form__Helpers.opt_of_string(userAgent());
  var match$2 = use();
  var clearUTMParams = match$2[1];
  var utm = match$2[0];
  var clearedParams = React.useRef(false);
  var mutate = function () {
    var match = utm.medium;
    var pageView_campaign = utm.campaign;
    var pageView_content = utm.content;
    var pageView_data = Core__Option.map(page.data, (function (d) {
            return d;
          }));
    var pageView_medium = match !== undefined ? (
        match === "WEB" ? "WEB" : "EMAIL"
      ) : undefined;
    var pageView_page = page.page;
    var pageView_queryParams = (function (x) {
          if (x === "") {
            return ;
          } else {
            return x;
          }
        })(queryParams.toString());
    var pageView_resourceId = page.resourceId;
    var pageView_resourceType = page.resourceType;
    var pageView_secondaryResourceId = page.secondaryResourceId;
    var pageView_secondaryResourceType = page.secondaryResourceType;
    var pageView_source = utm.source;
    var pageView_viewedAt = Scalars.DateTime.fromJsDate(new Date());
    var pageView = {
      campaign: pageView_campaign,
      content: pageView_content,
      data: pageView_data,
      medium: pageView_medium,
      page: pageView_page,
      path: currentPath,
      previousPath: previousPath,
      queryParams: pageView_queryParams,
      referrer: referrer,
      resourceId: pageView_resourceId,
      resourceType: pageView_resourceType,
      secondaryResourceId: pageView_secondaryResourceId,
      secondaryResourceType: pageView_secondaryResourceType,
      source: pageView_source,
      userAgent: userAgent$p,
      viewedAt: pageView_viewedAt
    };
    var qualifiedAgentId = page.qualifiedAgentId;
    if (qualifiedAgentId !== undefined) {
      recordPageView({
            input: {
              pageView: pageView,
              viewer: {
                viewerId: qualifiedAgentId,
                viewerType: "QA"
              }
            }
          }, undefined, undefined, undefined, undefined, undefined, undefined);
    } else {
      recordPageViewForLoggedInUser({
            input: {
              pageView: pageView
            }
          }, undefined, undefined, undefined, undefined, undefined, undefined);
    }
    var match$1 = anyIsPresent(utm);
    if (match$1) {
      clearUTMParams();
      clearedParams.current = true;
      return ;
    }
    
  };
  var stringifiedPage = React.useMemo((function () {
          return JSON.stringify(page);
        }), [page]);
  React.useEffect((function () {
          if (clearedParams.current === true) {
            clearedParams.current = false;
          }
          
        }), [stringifiedPage]);
  React.useEffect((function () {
          if (isImpersonated && clearedParams.current === false) {
            
          } else {
            mutate();
          }
        }), [
        isImpersonated,
        stringifiedPage
      ]);
}

function PageViews$RecordPageView(props) {
  useRecordPageView(props.page);
  return null;
}

var RecordPageView = {
  make: PageViews$RecordPageView
};

exports.Page = Page;
exports.UTM = UTM;
exports.RecordPageViewV5Mutation = RecordPageViewV5Mutation;
exports.RecordPageViewForLoggedInUserMutation = RecordPageViewForLoggedInUserMutation;
exports.userAgent = userAgent;
exports.useRecordPageView = useRecordPageView;
exports.RecordPageView = RecordPageView;
/* config Not a pure module */
